import { useEffect, useState } from 'react';

import { listWorkspaces } from '../../api/workspaces';
import { returnToParam, safeReturnTo } from '../../lib/unlockDeepLink';

/**
 * "Back to your workspace" after following a workspace's "How to unlock" hint. Shown only when the
 * `return_to` address is one of this organization's own workspaces (see `safeReturnTo`).
 */
export function ReturnToWorkspace({ search }: { search: string }) {
  const raw = returnToParam(search);
  const [href, setHref] = useState('');
  useEffect(() => {
    let active = true;
    if (!raw) {
      setHref('');
      return () => { active = false; };
    }
    listWorkspaces()
      .then((workspaces) => { if (active) setHref(safeReturnTo(raw, workspaces)); })
      .catch(() => { if (active) setHref(''); });
    return () => { active = false; };
  }, [raw]);
  if (!href) return null;
  return (
    <p className="return-to-workspace">
      <a href={href}>Back to your workspace</a>
    </p>
  );
}
